var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvgPurchaseOrderPending(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_420_52600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 8C2.5 7.54281 2.87614 7.16667 3.33333 7.16667C3.79052 7.16667 4.16667 7.54281 4.16667 8C4.16667 8.45719 3.79052 8.83333 3.33333 8.83333C2.87614 8.83333 2.5 8.45719 2.5 8ZM11.8333 8C11.8333 7.54281 12.2095 7.16667 12.6667 7.16667C13.1239 7.16667 13.5 7.54281 13.5 8C13.5 8.45719 13.1239 8.83333 12.6667 8.83333C12.2095 8.83333 11.8333 8.45719 11.8333 8ZM7.16667 8C7.16667 7.54281 7.54281 7.16667 8 7.16667C8.45719 7.16667 8.83333 7.54281 8.83333 8C8.83333 8.45719 8.45719 8.83333 8 8.83333C7.54281 8.83333 7.16667 8.45719 7.16667 8Z",
    fill: "white",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_420_52600"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgPurchaseOrderPending);
export default __webpack_public_path__ + "static/media/svg_purchase_order_pending.5de8e03781ebb6f6a27ab20da631f476.svg";
export { ForwardRef as ReactComponent };